<template>
  <div>
    <!-- Map Area Starts -->
    <section class="map-area section-padding section product_section_new" style="height: 900px;">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated jjfangan_zt1"
          style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">产品中心</p>
        <p class="p2 animate zoomIn animated jjfangan_zt2"
          style="animation-duration: 1s; animation-delay: 1s; visibility: visible;">PRODUCTS</p>
        <P class="p3 animate fadeInUp animated jjfangan_zt4"
          style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">
        <div class="chanpin">
          拿度磁致伸缩位移/液位传感器,DIMETIX激光测距传感器具有绝对位移测量、精度高、永不磨损、坚固耐用、运行可靠、耐严苛环境等优点，广泛应用于液压伺服、冶金制造，工控机械、石化、水利、灌装、风电光伏等。</div>
        </P>
        
      </div>
      <!-- <div class="animate bounce animated" style="width: 100%; height: 100px; line-height: 100px; text-align: center;animation-duration: 1s; animation-delay: 1s; visibility: visible;">
  	    		  <img src="/static/assets/images/shubiao.png"/>
  	    	  </div> -->
    </section>
    <!-- Map Area End -->
    <!-- 合作伙伴 starts -->

    <section class="jobs-area section-padding2">

      <div class="product_sun_tab">

        <div class="yingyongfenlei zengjiaxin">
          <div style="text-align: center;position: relative;">右滑查看更多分类-></div>
        </div>
        <div class="sun_tab_fu">
          <div class="sun_tab_fu1">
            <div class="sun_tab_fu2  animate fadeInLeft animated"
              style="animation-duration: 0.6s; animation-delay: 0.1s;">
              <!-- <div  class="suntab_xun xuanzhong">
								<div class="sun_xuna"></div>
								<div class="sun_xunb">
									<p>磁致传感器</p>
									<p style="font-size: 12px;">MAGNETOSTRICTIVE SENSOR</p>
								</div>
								<div class="sun_xunc xuanzhonga"></div>
								
							</div> -->
              


              <div v-for="(item, index) in chanpintab.son" :key="index" @mouseover="handleMouseOver(item.scode)"
                @mouseleave="handleMouseLeave(item.scode)" class="suntab_xun">
                <div v-if="item.scode == itemscode" class="sun_xuna xuanzhong"></div>
                <div v-else class="sun_xuna"></div>

                
                <div v-if="item.scode == itemscode" class="sun_xunb" >
                  
                  <p v-if="item.scode == scodein" style="font-weight:600;color: #4bbfbc;" >{{ item.name }}</p>
                  <p v-else style="font-weight:600; " >{{ item.name }}</p>

                  <p class="buxianshichanpin" style="font-size: 12px;">{{ item.subname }}</p>
                  
                </div>


                <div v-else class="sun_xunb">
                  <p style="font-weight:600;">{{ item.name }}</p>
                  <p class="buxianshichanpin" style="font-size: 12px;">{{ item.subname }}</p>
                </div>
                <div v-if="item.scode == itemscode" class="sun_xunc xuanzhonga"></div>
                <div v-else class="sun_xunc"></div>
              </div>

            </div>
          </div>
        </div>

        <!-- 
        <div v-if="listinfo.length > 0" class="sun_tab_fub  animate fadeInUp80 animated"
          style="animation-duration: 0.3s; animation-delay: 0.1s;"> -->

        <!-- <div v-for="(item, index) in listinfo" :key="index" @mouseover="handleMouseOverb(item.scode)"
            @mouseleave="handleMouseLeaveb(item.scode)" class="sun_tab_fub_01">
            <span v-if="item.scode == itemscodeb" class="huadongziti" style="color:#4bbfbc;">
              <span style="font-size: 20px;font-weight: bold;" class="huadongzitiq">{{ item.name }}</span><br>
              {{ item.subname }}
              <div class="sun_tab_fub_02">●</div>
            </span>
            <span v-else class="huadongziti">
              <span style="font-size: 20px;font-weight: bold;" class="huadongzitiq">{{ item.name }}</span><br>
              {{ item.subname }}
              <div class="sun_tab_fub_02">●</div>
            </span>

          </div> -->
        <!-- <div class="sun_tab_fub_01 touming">
						<span style="font-size: 20px;font-weight: bold;">磁致伸缩位移传感器</span><br>
						Magnetostrictive displacement sensor
						<div class="sun_tab_fub_02">●</div>
					</div> -->

        <!-- </div> -->

      </div>

      <div class="chanpin_s1">

        <div v-for="(item, index) in pubiclist" :key="index" class="chanpin_s1_01  animate zoomIn animated"
          style="animation-duration: 0.6s; animation-delay: 0.1s;">
          <a :href="'/chanpin?id=' + item.id" target="_blank">
            <div class="chanpin_s101_a">
              <div class="chanpin_s101_a1">
                <img :src="newurl + item.ico" style="height:auto" />
              </div>
              <div class="chanpin_s101_a2">
                {{ item.title }}
              </div>
            </div>
          </a>
        </div>



      </div>

    </section>

    <!-- 合作伙伴 end -->



  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      scodein: 7,
      daohanglist: [],
      chanpintab: [],
      itemscode: 8,
      thisid: 8,
      itemscodeb: 27,
      mouseOverFired: false, // 初始化标志位为 false
      mouseOverFiredb: false,
      listsp: [],
      pubiclist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
      listinfo: [
        {
          id: '',
          title: '',
          en: '',

        },
        {
          id: '',
          title: '',
          en: '',

        }
      ],
    }
  },
  mounted() {
    // 获取当前id
    console.log(this.scodein);
    
    this.thisid = this.$route.query.id;
    this.itemscode = this.thisid;
    this.scodein = this.thisid;
    this.qingqiufenlei(this.thisid);
    this.chanpinlist(this.thisid);
    //导航数据
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.daohanglist = response.data.data;
        this.chanpintab = this.daohanglist[1];

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    listinfoan() {

    },
    handleMouseOver(event) {
      if (!this.mouseOverFired) {
        // 设置标志位，表示已经触发过一次
        this.scodein = event;
        this.mouseOverFired = true;
        this.qingqiufenlei(event);
        this.chanpinlist(event)
      }
    },
    handleMouseLeave(event) {
      // 移动走鼠标
      this.mouseOverFired = false;
      this.itemscode = event
    },

    handleMouseOverb(event) {
      if (!this.mouseOverFiredb) {
        this.scodein = event;
        // 设置标志位，表示已经触发过一次
        this.mouseOverFiredb = true;
        this.chanpinlist(event)
      }
    },
    handleMouseLeaveb(event) {
      // 移走鼠标
      this.mouseOverFiredb = false;
      this.itemscodeb = event
    },
    qingqiufenlei(e) {
      //导航数据
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav/scode/' + e, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          // console.log(response.data.data);
          this.listinfo = response.data.data;
        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });
    },

    chanpinlist(e) {

      //产品列表
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + e + '/page/1/num/100', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          // console.log(response.data.data);
          this.pubiclist = response.data.data;
        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });

    }

  }
}
</script>





// WEBPACK FOOTER //
// JobCategory.vue?f41dcd06